<div *ngIf="isVisible" class="toast-container">
  <div class="toast">
    <div class="toast-icon">
      <i class="material-icons">{{ icon }}</i>
    </div>
    <div class="toast-content">
      <p>{{ message }} {{ progress }} / {{ cantidadFacturas }}</p>
      <div class="progress-bar" [style.width]="progress + '%'"></div>
    </div>
  </div>
</div>
